export default "__VITE_ASSET__C$pfyh8s__"